var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 92",
    x: 1.22461,
    y: 0.386719,
    width: 12.474,
    height: 11.2266,
    rx: 1.8711,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M0.912598 4.75262H14.634",
    stroke: "#949494",
    strokeWidth: 1.2474
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M4.9668 4.75262L4.9668 11.6133",
    stroke: "#949494",
    strokeWidth: 1.2474
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M9.95605 4.75262L9.95605 11.6133",
    stroke: "#949494",
    strokeWidth: 1.2474
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.8d5c322c1c29b3ec1a5f91ef6bc3040f.svg";
export { ForwardRef as ReactComponent };